export default __webpack_public_path__ + "static/websupport-a4b9991178a6a760a83e57bf7d8ffb55.png";